<script setup>
import { onMounted, ref } from 'vue'
import { Gems } from "../gems"
import { HUB } from '../hub'
import store from "../store"
import Menu from '../components/Menu'

const files = ref([])

function AttachDoc() {
    document.getElementById("attach-document").click()
}

async function Send() {
    if (HUB.RequiredFieldsValid()) {
        Gems.Telegram("Quer reportar esta situação?", "tele-info", "", "").then(
            async () => {
                const btn = document.getElementById("btn-send")
                btn.innerText = "AGUARDE..."
                btn.setAttribute("disabled", true)
                btn.style.cursor = "default"

                const subject = document.getElementById("txt-subject")
                const description = document.getElementById("txt-description")
                const type = document.getElementById("ddl-types")
                const formData = new FormData()

                formData.append(
                    "input",
                    JSON.stringify({
                        application: "HUB",
                        subject: subject.value,
                        type: type.value,
                        description: description.value,
                        user_name: store.getters.User.name,
                        user_email: store.getters.User.email,
                    })
                )

                files.value.forEach((file) =>
                    formData.append("documents[]", file)
                )

                try {
                    const response = await Gems.CallWS({
                        method: "post",
                        app: "intime",
                        action: "send-task",
                        body: formData,
                    })
                    if (response.status !== 200) {
                        Gems.Telegram("Não foi possível reportar esta situação", "tele-not-allowed")
                        return
                    }

                    Gems.Telegram("Recebemos a sua solicitação. Responderemos o mais brevemente possível", "tele-info", "")
                    document.getElementById("ddl-types").value = 1
                    subject.value = ""
                    description.value = ""
                    files.value = []
                    document.getElementById("attach-document").value = ""

                } finally {
                    btn.innerText = "ENVIAR"
                    btn.removeAttribute("disabled")
                    btn.style.cursor = "pointer"
                }
            },
            () => { }
        );
    }
}

function RemoveFile(i) {
    files.value.splice(i, 1)
}

function OpenHelpForm() {
  const toggle = document.getElementById("help-request-toggle");
  if (!toggle) return;
  const content = toggle.nextElementSibling;
  if (content && content.classList.contains("hidden")) {
    toggle.click();
  }
  toggle.scrollIntoView({ behavior: "smooth", block: "start" });
  setTimeout(() => {
    const subject = document.getElementById("txt-subject");
    if (subject) subject.focus();
  }, 300);
}

onMounted(() => {
    //Dropdowns
    document.querySelectorAll('.help-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => {
            const content = toggle.nextElementSibling
            const icon = toggle.querySelector('i')
            content.classList.toggle('hidden')
            icon.classList.toggle('rotated')
        })
    })
    
    document
        .getElementById("attach-document")
        .onchange = (e) => {
            files.value.push(...e.target.files)
            e.target.value = ""
        }
})

</script>


<template>
    <div id="div-container" class="main-container-background">
        <Menu></Menu>
        <div class="page-container">
            <img class="img-inpeople-default" src="../images/inpeople.png">

            <div class="div-right">
                <div class="div-task">

                    <div class="help-item">
                        <div class="help-toggle">
                            <span>Tabelas</span>
                            <i class="fas fa-chevron-down"></i>
                        </div>

                        <div class="help-content hidden">
                            <p>
                                Para dar início à configuração das informações dos utilizadores, deverá aceder ao painel principal do inPeopleHub, selecionando em seguida a opção ‘Tabelas’, na secção ‘Administração’.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-1.jpg" alt="help-image" />
                            <br>
                            <p>
                                Neste separador, encontrará diversas tabelas que deve exportar.
                            </p>
                            <p>
                                Para exportar uma tabela, basta selecionar o botão "Exportar", que se encontra acima de cada tabela e que irá gerar um ficheiro Excel correspondente à mesma.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-2.jpg" alt="help-image" />
                            <br>
                            <p>
                                Depois, deverá abrir o ficheiro, preencher a tabela e gravar no formato CSV UTF-8.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-3.jpg" alt="help-image" />
                            <br>
                            <p>
                                Antes de importar a tabela na plataforma, verifique as informações apresentadas no canto superior esquerdo, que indicam as regras de importação necessárias para que o carregamento seja realizado corretamente.
                            </p>
                            <p>
                                Posteriormente, para importar o ficheiro, deverá selecionar no botão ‘Importar’, seguido do documento previamente gravado no formato CSV UTF-8 e, por fim, confirmar a importação selecionando novamente no botão ‘Importar’ (que se destacará visualmente, alternando de cor, durante o processo).
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-4.jpg" alt="help-image" />
                            <br>
                            <p>
                                No final desta página, existe a possibilidade de importar várias tabelas em simultâneo. Para isso, deverá selecionar o botão ‘Incluir Ficheiros’, seguido de todos os ficheiros no formato CSV UTF-8 e em seguida, carregar em ‘Iniciar Processo’.
                            </p>
                            <p>
                                Recordo ainda, que todos os ficheiros que forem aqui introduzidos deverão seguir as regras de importação existentes para cada tabela, tal como as regras de importação existentes neste campo.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-5.jpg" alt="help-image" />
                            <br>
                            <p>
                                Nota importante: este processo apenas será válido se cada tabela for gravada com o nome da sua palavra-chave, ou seja, o nome que surge entre aspas no botão de exportação da respetiva tabela.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-6.jpg" alt="help-image" />
                            <br>
                            <p>
                                Após o carregamento destas tabelas, os dados ficam disponíveis em todos os sistemas integrados do inPeopleHub.
                            </p>
                        </div>
                    </div>
                    
                    <div class="help-item">
                        <div class="help-toggle">
                            <span>Hierarquia</span>
                            <i class="fas fa-chevron-down"></i>
                        </div>

                        <div class="help-content hidden">
                            <p>
                                A hierarquia pode ser carregada através de uma tabela ou diretamente pela interface disponível na secção ‘Administração’, separador ‘Hierarquia’.
                            </p>
                            <p>
                                Para definir a hierarquia, deverá selecionar o(s) utilizador(es) pretendido(s) e arrastá-lo(s) para a posição desejada. É possível selecionar vários utilizadores em simultâneo, caso se pretenda posicioná-los no mesmo nível hierárquico.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-7.jpg" alt="help-image" />
                            <br>
                        </div>
                    </div>

                    <div class="help-item">
                        <div class="help-toggle">
                            <span>Definições</span>
                            <i class="fas fa-chevron-down"></i>
                        </div>

                        <div class="help-content hidden">
                            <p>
                                No separador Definições, pode carregar o logótipo da sua empresa, que será exibido nos menus de todos os sistemas contratados, facilitando a identificação da empresa em que o utilizador se encontra a trabalhar.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-14.jpg" alt="help-image" />
                            <br>
                            <p>
                                A opção "Utilizadores podem carregar a foto de perfil" permite que cada utilizador adicione e atualize autonomamente a sua fotografia de perfil quando esta funcionalidade estiver ativa.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-11.jpg" alt="help-image" />
                            <br>
                        </div>
                    </div>

                    <div class="help-item">
                        <div class="help-toggle">
                            <span>Utilizadores</span>
                            <i class="fas fa-chevron-down"></i>
                        </div>

                        <div class="help-content hidden">
                            <p>
                                Para aceder à lista de utilizadores e respetivas permissões, deverá selecionar a secção “Administração” no painel inPeopleHub e, de seguida, a opção “Utilizadores”.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-8.jpg" alt="help-image" />
                            <br>
                            <p>
                                Nesta página, é apresentada a listagem completa dos utilizadores existentes no sistema, organizada por três grupos distintos:
                            </p>
                            <ul>
                                <li>Ativos - Utilizadores que mantêm acesso a pelo menos um dos sistemas associados;</li>
                                <li>Inativos - Utilizadores que deixaram de ter acesso em todos os sistemas;</li>
                                <li>Anonimizados - Utilizadores cujo período de inatividade se prolongou por mais de 13 meses.</li>
                            </ul>
                            <p>
                                A secção “Anonimizados” reúne, assim, os perfis que estiveram inativos de forma contínua durante esse período. Após ultrapassado o limite de 13 meses, o sistema procede automaticamente à transformação dos dados pessoais associados ao utilizador, substituindo-os por informação anonimizada, conforme apresentado na imagem. Desta forma, todo o conteúdo que poderia permitir a sua identificação é removido, garantindo o cumprimento das regras de proteção e retenção de dados.
                            </p>
                            <p>
                                 O processo de anonimização será aplicado aos utilizadores que tenham todas as opções dos sistemas contratualizados desativadas, garantindo que apenas contas totalmente inativas e sem acesso a qualquer módulo sejam consideradas para anonimização.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-12.jpg" alt="help-image" />
                            <br>
                            <p>
                                Ao selecionar um utilizador da lista, é possível visualizar várias informações associadas. Determinados campos são dinâmicos e podem ser atualizados diretamente nesta interface, enquanto outros requerem atualização através de tabelas ou separadores específicos.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-13.jpg" alt="help-image" />
                            <br>
                            <p>
                                No canto superior direito, encontra ainda a opção de 'Filtrar por' que permite alternar entre os grupos de utilizadores ativos, inativos e anonimizados, possibilitando visualizar apenas o tipo de registo que pretende consultar e também um campo de pesquisa que permite localizar rapidamente qualquer utilizador.
                            </p>
                            <br>
                            <img src="@/images/admin-ajuda-9.jpg" alt="help-image" />
                            <br>
                            <p>
                                E por último, está disponível o ícone "+", que permite criar um utilizador. Para isso, deverá preencher todos os campos obrigatórios e selecionar o botão ‘Criar Utilizador’.
                            </p>
                             <br>
                            <img src="@/images/admin-ajuda-10.jpg" alt="help-image" />
                            <br>
                        </div>
                    </div>

                    <div class="help-item">
                        <div class="help-toggle">
                            <span>Licenciamento</span>
                            <i class="fas fa-chevron-down"></i>
                        </div>

                        <div class="help-content hidden">
                            <p>
                                Na opção Licenciamento, poderá ser consultado, a qualquer momento, o Contrato de Licenciamento associado à utilização do sistema.
                            </p>
                        </div>
                    </div>

                    <div class="help-item">
                        <div class="help-toggle" id="help-request-toggle">
                            <span>Pedido de ajuda</span>
                            <i class="fas fa-chevron-down"></i>
                        </div>

                        <div class="help-content hidden">
                            <p>
                                Caso tenha dúvidas ou dificuldades técnicas, poderá enviar uma mensagem com a descrição detalhada da situação. 
                            </p>
                            <p>
                                Recomendamos que leia a informação disponível dentro da página de "Ajuda" no sistema que está a utilizar.
                            </p>
                            <div class="form-area">
                                <div class="div-filters">
                                    <div class="div-label-container">
                                        <div class="div-label label">TIPO:</div>
                                    </div>
                                    <div class="div-inputs">
                                        <select name="ddl-types" id="ddl-types" class="dll-types" required>
                                            <option value="1">Selecione uma opção</option>
                                            <option value="Dificuldade técnica">Dificuldade técnica</option>
                                            <option value="Dúvida na utilização / navegação">Dúvida na utilização / navegação</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="div-filters">
                                    <div class="div-label-container">
                                        <div class="div-label label">ASSUNTO:</div>
                                    </div>
                                    <div class="div-inputs">
                                        <input id="txt-subject" name="txt-subject" type="text" class="txt-input" required />
                                    </div>
                                </div>

                                <div class="div-filters">
                                    <div class="div-label-container div-description">
                                        <div class="div-label-desc label">DESCRIÇÃO:</div>
                                    </div>
                                    <div colspan="2" class="div-inputs div-textarea">
                                        <textarea id="txt-description" name="txt-description" type="text" class="txt-area"
                                            required></textarea>
                                    </div>
                                </div>

                                <div class="div-filters">
                                    <div class="btns inputs-border div-inputs hover-inputs-border" colspan="2">
                                        <button id="btn-send" type="button" class="button" @click="Send()">
                                            ENVIAR
                                        </button>
                                    </div>
                                </div>

                                <div class="div-document">
                                    <div class="btns inputs-border div-inputs hover-inputs-border" colspan="2">
                                        <input type="file" id="attach-document" class="hidden" multiple />
                                        <button id="btn-attach-document" @click="AttachDoc()" class="button">
                                            ANEXAR FICHEIRO
                                        </button>
                                    </div>
                                </div>

                                <div class="div-filters">
                                    <div class="div-label-container"></div>
                                    <div colspan="2" class="div-inputs">
                                        <div id="doc-list">
                                            <div v-for="(file, i) in files" :key="i" class="div-file">
                                                <span class="file-name">{{ file.name }}</span>
                                                <i class="fas fa-times remove-file cursor-pointer" @click="RemoveFile(i)"
                                                    @mouseover="Gems.Tooltip($event.target, 'Remover', 'tooltip')"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="help-btn-area">
        <div class="btns inputs-border div-inputs hover-inputs-border">
            <button type="button" class="button" @click="OpenHelpForm()">
            Preciso de ajuda
            </button>
        </div>
    </div>
</template>


<style scoped>
#div-container {
    display: flex;
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
}

.page-container {
    display: flex;
    flex-direction: column;
    padding: 25px 35px 25px 14px;
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
}

.img-inpeople-default {
    margin-bottom: 27px;
    max-width: 100%;
    height: auto;
}

.div-content {
    text-align: center;
    width: 100%;
    margin-top: 50px;
}

.div-label-container {
    text-align: right;
    width: 100px;
}

.label {
    font-size: 10pt;
    padding-right: 10px;
    display: inline-block;
}

.lbl {
    font-size: 20pt;
    opacity: .3;
    margin-bottom: 23px;
}

.dll-types {
    width: 100%;
    padding: 10px;
    border-radius: 7px;
}

.txt-area {
    width: 100%;
    resize: vertical;
    height: 250px;
    padding: 10px;
    border-radius: 7px;
    min-height: 150px;
}

.txt-input {
    width: 100%;
    padding: 10px;
    border-radius: 7px;
}

.div-description {
    align-self: start !important;
}

.div-label-desc {
    margin-top: 13px;
}

.btns {
    text-align: left;
}

.div-task {
    width: 900px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    border-spacing: 5px;
    gap: 5px;
    margin-bottom: 50px;
}

.help-icon {
    font-size: .7em;
}

.div-filters {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.div-inputs {
    width: calc( 100% - 100px );
    min-width: 367px;
}

.div-inputs input {
    border: none;
}

.div-textarea {
    display: flex;
    justify-content: center;
    align-items: center;
}

.div-document {
    display: flex;
    justify-content: flex-end;
}

.div-right {
    display: flex;
    justify-content: center;
    align-items: center;
}

.div-file {
    display: flex;
    justify-content: space-between;
    text-align: left;
    cursor: default;
    align-items: center;
    width: 100%;
}

.break-word {
    word-break: break-all;
}

.remove-file {
    color: orangered;
    cursor: pointer;
}

.file-name {
    font-size: 0.7em;
    font-weight: 600;
}

.help-item {
  position: relative;
  width: 100%;
  max-width: 100%;
  border-top: 1px solid var(--medium-gray-color, #444);
  padding: 6px 0;
}

.help-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-weight: 600;
  color: var(--medium-gray-color);
  padding: 10px 0;
}

.help-toggle:hover {
  color: var(--default-hover-color);
}

.help-toggle i {
  transition: transform .2s ease;
}

.help-toggle i.rotated {
  transform: rotate(180deg);
}

.help-content {
  width: 100%;
  padding: 0 4px 10px 4px;
  overflow: hidden;
  transition: all .2s ease;
}

.help-content img,
.help-content video,
.help-content canvas {
  max-width: 100%;
  height: auto;
  display: block;
}

.help-content.hidden {
  display: none !important;
}

.help-content .div-filters {
  margin-bottom: 5px;
}

.form-area {
    width: 650px;
    max-width: 100%;
    margin: 50px auto;
}

.help-btn-area {
  position: fixed;
  right: 15px;
  bottom: calc( 2% + 15px );
  z-index: 100;
  max-width: 90vw;
}

.help-btn-area .div-inputs {
  width: auto;
  min-width: 0;
}

@media (max-width: 700px) {
  .div-filters {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    row-gap: 6px;
  }

  .div-filters .dll-types { margin-bottom: 6px; }

  .div-label-container {
    width: 100%;
    text-align: left;
    margin: 0;
  }

  .div-inputs {
    width: 100%;
    min-width: 0;
  }

  .div-description {
    align-self: auto !important;
  }

  .txt-area{
    margin-bottom: 10px;
  }
  
  .btns,
  .div-document {
    justify-content: flex-start;
  }
}
</style>